import React, {useState} from "react";
import { motion } from "framer-motion";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";

//27 Nov 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

export default function EtAboutCTA() {

  // First Created - 22 Nov 2025
  // Author - Atul Pandey
  // Purpose — Et About CTA
  // Updated - 27 Nov 2025 - Refined for Unified CTA - ctaSource
          
  // 1 -  Local UI state 
  const [open, setOpen] = useState({ visible: false, source: null }); // 27 Nov 2025 - unified CTA

  return (
    <section 
      id="about-cta"
      className="py-20 bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 text-white text-center relative">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      <motion.div
        className="relative z-10 max-w-3xl mx-auto px-4"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Let’s Shape Your Growth Story
        </h2>

        <p className="text-orange-100 mb-8 text-lg">
          Ready to explore what Eternity & Trinity can unlock for you?
        </p>

        <a
          // href="/contact"
          onClick={() => setOpen({ visible: true, source: "about-cta" })} // 27 Nov 2025
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition cursor-pointer"
        >
          <RocketLaunchIcon className="h-6 w-6" />
          Connect With Us
        </a>
      </motion.div>
      {/* 27 Nov 2025 */}
      {open.visible && (
        <EtModalContactConversation
          open={open}
          onClose={() => setOpen({ visible: false, source: null })}
        />
      )}
    </section>
  );
}